export const popupList = [
  { name: "note", title: "Take Note", icon: "note" },
  { name: "digest", title: "Highlight", icon: "highlight" },
  { name: "translation", title: "Translate", icon: "translation" },
  { name: "copy", title: "Copy", icon: "copy" },
  { name: "search-book", title: "Search in the book", icon: "search-book" },
  { name: "google", title: "Search on the internet", icon: "google" },
  { name: "speaker", title: "Speak the text", icon: "Speaker" },
];
